<template lang="pug">
.tw-flex.tw-items-center.tw-gap-2.tw-justify-start
	template(v-if='showName')
		div(v-if='passenger.data.name'): h4 {{passenger.data.name}} {{passenger.data.surname}}
		div(v-else-if='typeof(passengerIdx) == "number"'): h4 {{$t("common.passenger", 0)}} {{(passengerIdx + 1)}}
	div
		v-text-field(
			ref='inputField'
			v-model="passenger.data.cartaFreccia"
			:rules="cartaFrecciaRules"
			required
			:label="label"
			:hint="$t('form_labels.cartafreccia_explanation', 'Inserire il codice X_GO o della CartaFRECCIA (Base/Argento/Oro/Platino/Platino Infinito)')"
			persistent-hint
			placeholder="Cartafreccia"
			variant='solo'
			condensed
			class="tw-min-w-[200px]"
			:disabled="disabled"
			clearable
		)
</template>

<script setup>
import {useI18n} from "vue-i18n";
import { onMounted, watch, ref, computed} from "vue";
import {get as _get} from 'lodash-es';


const i18n = useI18n();
const inputField = ref();
const props = defineProps({
	passenger: { type: Object, required: true },
	passengerIdx: { type: Number, required: false },
	showName: { type: Boolean, default: true, required: false},
	parameterErrors: { type: Object, required: false },
	required: { type: Boolean, required: false, default: false }
});
const disabled = computed(() => {
	return Boolean(_get(props.passenger, 'data.customerKey'));
})
const label = computed(() => {
	return i18n.t('form_labels.cartafreccia', 'CartaFRECCIA / X-GO') + (props.required ? ' *' : '');
});
const cartaFrecciaRules = [
	v => {
		if(props.required && !v) return i18n.t('common.required_field');
		if(v && v.length != 9) return i18n.t('common.rules.cartafreccia');
		return true;
	},
	v => _get(props.parameterErrors, [props.passenger.data.xmlId, 'cartaFreccia.validationMessages', 0]) || true,
	v => !_get(props.passenger, 'data.cartaFrecciaErr') || i18n.t('form_labels.cartafreccia_err', 'CartaFreccia errata.')
];


watch(() => [props.parameterErrors, props.passenger], () => {
	if(inputField.value) inputField.value.validate(true);
});


onMounted(() => {
	if (!props.passenger.data.cartaFrecciaErr) {
		props.passenger.data.cartaFrecciaErr = false;
	}
});
</script>

<style scoped>

</style>